var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarTimeIcon = function SvgCalendarTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 142 141"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M.5 0h141v141H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M101.844 17.625h17.625c6.074 0 11.015 4.942 11.015 11.016v92.531c0 6.074-4.941 11.016-11.015 11.016H22.531c-6.074 0-11.015-4.942-11.015-11.016V28.641c0-6.074 4.941-11.016 11.015-11.016h17.625V8.813h4.407v8.812h52.875V8.813h4.406zm-61.688 4.406H22.531a6.617 6.617 0 0 0-6.61 6.61v13.218h110.157V28.641a6.617 6.617 0 0 0-6.609-6.61h-17.625v8.813h-4.406V22.03H44.563v8.813h-4.407zm79.313 105.75H22.531a6.617 6.617 0 0 1-6.61-6.609V46.266h110.157v74.906a6.617 6.617 0 0 1-6.609 6.609M68.797 59.484h4.406v27.729l17.61 17.609-3.115 3.116-18.901-18.9z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendarTimeIcon;